// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/BusinessSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/BusinessSearchBy.proto.
 */
export const file_Enumerations_BusinessSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CiNFbnVtZXJhdGlvbnMvQnVzaW5lc3NTZWFyY2hCeS5wcm90bxIadGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMqwAEKEEJ1c2luZXNzU2VhcmNoQnkSKAocQlVTSU5FU1NfU0VBUkNIX0JZX1RFTkFOVF9JRBAAGgbKx80PAQMSIwoXQlVTSU5FU1NfU0VBUkNIX0JZX05BTUUQARoGysfNDwEEEioKHkJVU0lORVNTX1NFQVJDSF9CWV9ERVNDUklQVElPThACGgbKx80PAQUSMQolQlVTSU5FU1NfU0VBUkNIX0JZX0VYVEVSTkFMX1JFRkVSRU5DRRADGgbKx80PAQdCKKoCJU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5FbnVtZXJhdGlvbnNiBnByb3RvMw", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of a business can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.BusinessSearchBy
 */
export enum BusinessSearchBy {
  /**
   * Search through the tenant id of a business.
   *
   * @generated from enum value: BUSINESS_SEARCH_BY_TENANT_ID = 0;
   */
  TENANT_ID = 0,

  /**
   * Search through the name of a business.
   *
   * @generated from enum value: BUSINESS_SEARCH_BY_NAME = 1;
   */
  NAME = 1,

  /**
   * Search through the description of a business.
   *
   * @generated from enum value: BUSINESS_SEARCH_BY_DESCRIPTION = 2;
   */
  DESCRIPTION = 2,

  /**
   * Search through the external reference text of a business.
   *
   * @generated from enum value: BUSINESS_SEARCH_BY_EXTERNAL_REFERENCE = 3;
   */
  EXTERNAL_REFERENCE = 3,
}

/**
 * Describes the enum time_tracking.enumerations.BusinessSearchBy.
 */
export const BusinessSearchBySchema: GenEnum<BusinessSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_BusinessSearchBy, 0);

